import { RequestResponse } from '@core/services/request/model/request.model';
import { StringIdName } from '@core/domain/model/master/string-id-name.model';
import { MasterSelfAutoconsumptionApi } from '@core/api/model/master/master-self-autoconsumption-api.model';

export class MasterSelfConsumptionsMapper {
  public static requestFromApiToModel(api: RequestResponse<Array<MasterSelfAutoconsumptionApi>>): RequestResponse<Array<StringIdName>> {
    return {
      ...api,
      data: api.data.map(({ codigo, descripcion }) => ({ id: codigo, name: descripcion })),
    };
  }
}
